import { FC, memo, ReactElement } from 'react';

import { useAppPagination } from '@/common/hooks';
import { FallbackedLayout } from '@/common/layouts';

import { useGetAllSearchConsoleUrlInspectionDomainsQuery } from '@/modules/Domains';

import { SearchConsoleUrlInspectionListView } from './SearchConsoleUrlInspectionListView';

interface Props {
  siteId: string;
}

export const SearchConsoleUrlInspectionListContainer: FC<Props> = memo(({ siteId }) => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const {
    data: urlInspectionDomainsData,
    error: urlInspectionDomainsError,
    isLoading: isUrlInspectionDomainsLoading,
    isFetching: isUrlInspectionDomainsFetching,
    isError: isUrlInspectionDomainsError
  } = useGetAllSearchConsoleUrlInspectionDomainsQuery(siteId, { page: currentPage })({
    enabled: !!siteId
  });

  return (
    <FallbackedLayout
      isLoading={ isUrlInspectionDomainsLoading }
      error={ urlInspectionDomainsError }
      isError={ isUrlInspectionDomainsError }
      data={ urlInspectionDomainsData }
    >
      { (urlInspectionDomainsList): ReactElement => (
        <SearchConsoleUrlInspectionListView
          currentPage={ currentPage }
          urlInspectionDomainsItems={ urlInspectionDomainsList.items }
          urlInspectionDomainsTotalItems={ urlInspectionDomainsList.meta.totalItems }
          urlInspectionDomainsItemsPerPage={ urlInspectionDomainsList.meta.itemsPerPage }
          isLoading={ isUrlInspectionDomainsFetching }
          handleChangePage={ handleChangePage }
        />
      ) }
    </FallbackedLayout>
  );
});
